export default __webpack_public_path__ + "img/dypLizxD.eb605d64.svg";